import {DomainStore} from 'shared/store';
import {endpoints, types} from 'shared/core';
import CompanyDocument from 'stores/documents/CompanyDocument';

class OnboardDocumentStore extends DomainStore {
  async loadDocuments() {
    await this._compose([
      endpoints.PENDING_DOCUMENTS
    ]);

    return this._getAll(types.PENDING_DOCUMENT, CompanyDocument);
  }

  async markDocumentComplete(companyDocument, signature, annotations) {
    const doc = companyDocument.pick([]);
    const annotationValues = this.prepareAnnotationsForSave(annotations, signature);

    doc.merge({signature});
    doc.merge({annotationValues});

    return await this.patch(doc);
  }

  prepareAnnotationsForSave(annotations, signature) {
    return annotations.map(a => {
      return {
        id: a.annotation.annotationArgs.id,
        annotationType: a.annotation.annotationType,
        value: a.annotation.annotationType === 'input' ? a.value : signature,
        annotationArgs: {
          fontSize: a.annotation.annotationArgs.fontSize
        }
      };
    });
  }
}

const singleton = new OnboardDocumentStore();

export default singleton;
